import { Component, Fragment, h, Host, Prop, Watch } from '@stencil/core'
import { gsap } from 'src/lib/gsap'

import { ToastStore } from '../app/toast'
import { GetFathomBadge } from './ui'

@Component({
  tag: 'share-layout',
})
export class Layout {
  @Prop() showFooter = false
  @Prop() showLoader = false

  loaderEl: HTMLUiLoaderElement

  @Watch('showLoader')
  animateLoader() {
    gsap.to(this.loaderEl, {
      opacity: this.showLoader ? 1 : 0,
      duration: this.showLoader ? 0 : 0.3,
      onStart: () => (this.loaderEl.hidden = false),
      onComplete: () => (this.loaderEl.hidden = !this.showLoader),
    })
  }

  componentDidLoad() {
    if (this.showLoader) {
      this.animateLoader()
    }
  }

  render() {
    return (
      <Host class='flex overflow-hidden flex-col items-center w-screen h-screen text-glyph-base bg-surface-base'>
        {this.showFooter ? (
          <Fragment>
            <ui-scrollarea class='flex flex-grow w-full h-full'>
              <div class='flex flex-col py-4 h-full min-h-full'>
                <slot />
              </div>
            </ui-scrollarea>
            <footer class='flex flex-shrink-0 justify-center items-center py-4 text-sm font-medium text-glyph-lighter'>
              Powered by&nbsp;&nbsp;
              <ui-logo size='sm' class='mr-1' />
              <GetFathomBadge />
            </footer>
          </Fragment>
        ) : (
          <slot />
        )}
        <ui-loader
          hidden
          ref={(el) => (this.loaderEl = el)}
          class='flex fixed top-0 left-0 z-menu justify-center items-center w-screen h-screen bg-surface-base'
          style={{ fontSize: '40px', zIndex: '2147483647' }}
        />
        <div
          class='flex absolute inset-0 z-menu flex-col items-end px-4 pt-16 mt-1 transition duration-200 pointer-events-none spacing-y-2'
          style={{ '--tw-bg-opacity': '0.9' }}
        >
          {ToastStore.state.toasts.map((props) => (
            <ui-toast {...props} />
          ))}
        </div>
      </Host>
    )
  }
}
